import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const negatives = ['This is not a collection of random moves copied from the internet.', 'This is not a theoretical manual you need to rewrite before it works in a real class.', 'This is not content designed for a different kind of teacher that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-cream-dark border-y border-line relative overflow-hidden" data-id="element-268" data-mp="z25yeu5n3bp5">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-269" data-mp="u3l93prxecfh" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-270" data-mp="17zq3yfajbu5k">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-271" data-mp="13zob8vms2b2f">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-cream-light border border-gold mb-5" data-id="element-272" data-mp="2ffmlv3xlt55r">
            <span className="text-2xl" aria-hidden="true" data-id="element-273" data-mp="2bunpnjjb0a3n">
              🏆
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold uppercase mb-4 text-ink" data-id="element-274" data-mp="2gth3jd2i634c">
            The most complete hip hop dance teaching system for instructors
            worldwide
          </h2>
          <h3 className="text-xl font-bold uppercase text-burgundy mb-3" data-id="element-275" data-mp="2pu6ua2cwp3b7">
            Hip Hop Dance Instructor Ready
          </h3>
          <p className="text-base md:text-lg text-ink-soft mb-10" data-id="element-276" data-mp="1t3ee74pz3b9f">
            A complete 6-in-1 system: 4 volumes + 5 strategic bonuses · 100
            ready-to-teach classes · Everything ready to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-277" data-mp="26xnu42k2ypqs">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-cream-light p-6 rounded-2xl border border-line shadow-sm" data-id="element-278" data-mp="19h8b9chrcudl">
            {negatives.map((text, i) => <div key={i} className="flex items-start gap-3" data-id="element-279" data-mp="2cse1d9398bn6" data-mpi={i}>
                <XIcon className="text-burgundy shrink-0 mt-1" size={18} data-id="element-280" data-mp="2crvyvuq0116t" />
                <p className="text-ink-muted text-sm" data-id="element-281" data-mp="2qi94vrjby5ti">{text}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-burgundy p-6 rounded-2xl border border-burgundy-dark relative overflow-hidden shadow-sm" data-id="element-282" data-mp="2miquvqt1rf5g">
            <div className="flex items-start gap-3 relative z-10" data-id="element-283" data-mp="27tuff8onuzut">
              <CheckIcon className="text-gold-light shrink-0 mt-1" size={20} data-id="element-284" data-mp="22tghijgrx6ai" />
              <p className="text-cream-light font-medium text-base leading-relaxed" data-id="element-285" data-mp="3j87z01cdst51">
                This is a complete 6-in-1 professional teaching system — 4
                structured volumes covering every level, plus 5 strategic
                bonuses that cover everything else — so you walk into every
                class completely prepared, confident, and ready to deliver a
                session your students will genuinely feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}